import React from "react";
import DailyAllowanceMaster from "../../components/master/DailyAllowanceMaster";
import PageLayout from "../../components/PageLayout";

interface MasterPageProps {
  onLogout?: () => void;
  currentPage?: string;
  onNavigate?: (page: string) => void;
}

const DailyAllowanceMasterPage: React.FC<MasterPageProps> = ({ onLogout, currentPage, onNavigate }) => {
  return (
    <PageLayout onLogout={onLogout} currentPage={currentPage} onNavigate={onNavigate}>
      <DailyAllowanceMaster />
    </PageLayout>
  );
};

export default DailyAllowanceMasterPage;
